import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const WithdrawModalLazy = React.lazy(() =>
  import('./WithdrawModal').then((m) => ({ default: m.WithdrawModal })),
);

NiceModal.register(
  MODALS.WITHDRAW,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <WithdrawModalLazy />
    </Suspense>
  )),
);
